import React, { useEffect, useState } from "react";
import { Formik, Field } from "formik";
import {
  Button,
  Form,
  FormGroup,
  Container,
  Col,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import * as Yup from "yup";
import {
  countries,
  formatCountryCodes,
  salesorgs,
} from "../../Constants/static";
import MultiSelect from "@kenshooui/react-multi-select";
import ErrorMessage from "../../Utils/ErrorMessage";
import { connect, useDispatch } from "react-redux";
import Mapping from "../../Utils/Mapping";
import { Link, useParams } from "react-router-dom";
import {
  getRoles,
  createUser,
  getUserDetails,
  modifyUser,
} from "../../../actions/users";
import { Loading } from "../../../loader/Loading";
import { mandatoryFields } from "../../Utils/PoolConfig";
import SubmissionPopup from "./submissionModal";
import errors from "../../Constants/errors.json";
import DocumentTitle from "react-document-title";
import { isEmpty } from "lodash";
import ErrorFocus from "../../Error/ErrorFocus";
const CreateUserForm = (props) => {
  const [state, setState] = useState({
    modal: false,
    message: "",
    color: "",
    user: {},
    accessroles: [],
    initialAccessroles: [],
    existingStatus: false,
    userID: "",
    disabled: false,
    aTouch: false,
  });

  const temp = useParams()["*"];
  const userId = (temp !== "create") ? temp : undefined;

  const dispatch = useDispatch();
  const clearError = () => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  };
  // const clearRoles = () => {
  //   dispatch({ type: "SET_ROLES_LIST", data: { roles: undefined } });
  // };
  const clearUserCreated = () => {
    dispatch({ type: "SET_CREATE_USER", data: { usercreated: undefined } });
  };
  // const clearUserDetails = () => {
  //   dispatch({ type: "SET_USER_DETAILS", data: { userDetails: undefined } });
  // };
  const getUserDetailsMethod = (username) => dispatch(getUserDetails(username));
  // const getRolesMethod = () => dispatch(getRoles());
  const createUserMethod = (createUserObject) => dispatch(createUser(createUserObject));
  const modifyUserMethod = (updateUserObject) => dispatch(modifyUser(updateUserObject));
  const clearModifyUser = () => {
    dispatch({ type: "SET_MODIFY_USER", data: { userModified: undefined } });
  };

  const {
    userDetails,
    userCreated,
    userModified,
    roles,
    pool,
    error,
    isLoading,
  } = props;

  useEffect(() => {
    let newState = {};
    if (userCreated) {
      newState = {
        modal: true,
        message: userCreated,
        color: "success",
      };
    } else if (error) {
      let errorMessage = (error.code &&
        error.code.message &&
        error.code.message.message) ||
        error.message || <Mapping dictionary={errors} word={error.errorPath} />;
      newState = { modal: true, message: errorMessage, color: "danger" };
    } else if ((userDetails && roles && roles.length > 0) || userModified) {
      let userRoles = userDetails["custom:Groups"];
      let userRolesArray = (userRoles && userRoles.split(",")) || [];
      let finalRolesObjectArray = userRolesArray
        .map((userrole) => {
          return roles.find((role) => role.id === userrole);
        })
        .filter((r) => r);
      let nAccessRoles = state.aTouch
        ? state.accessroles
        : finalRolesObjectArray;
      newState = {
        accessroles: nAccessRoles,
        initialAccessroles: finalRolesObjectArray,
        existingStatus: !userDetails["Enabled"],
        modal: userModified ? true : false,
        message: userModified ? "User Modified Successfully" : "",
        color: userModified ? "success" : "",
      };
    }

    if (Object.keys(newState).length > 0) {
      setState((prevState) => ({
        ...prevState,
        ...newState,
      }));
    }
  }, [
    userCreated,
    userModified,
    error,
    userDetails,
    roles
  ]);

  useEffect(() => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
  }, []);

  useEffect(() => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
    dispatch(getRoles());
    dispatch({ type: "SET_CREATE_USER", data: { usercreated: undefined } });

    if (userId) {
      let newState = {
        userID: userId,
        disabled: true,
      };
      setState((prevState) => ({
        ...prevState,
        ...newState,
      }));
      dispatch(getUserDetails(userId));
    }
  }, [userId]);

  useEffect(() => {
    return () => {
      let newState = {
        modal: false,
        message: "",
        color: "",
      };
      setState((prevState) => ({
        ...prevState,
        ...newState,
      }));
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
      dispatch({ type: "SET_ROLES_LIST", data: { roles: undefined } });
      dispatch({ type: "SET_CREATE_USER", data: { usercreated: undefined } });
      dispatch({ type: "SET_USER_DETAILS", data: { userDetails: undefined } });
    };
  }, [dispatch]);

  const toggle = () => {
    let newState = {
      modal: !state.modal,
      message: "",
      color: "",
    };
    setState((prevState) => ({
      ...prevState,
      ...newState,
    }));
    state.userID && !error && getUserDetailsMethod(state.userID);
  };

  const optionListCountries = (list) => {
    return list.map((opt, index) => {
      return (
        <option value={opt} key={index}>
          {opt}
        </option>
      );
    });
  };

  // const optionList = (list) => {
  //   return list.map((opt, index) => {
  //     return (
  //       <option value={opt.value} key={index}>
  //         {opt.label}
  //       </option>
  //     );
  //   });
  // };

  const createUserObject = (formvalues) => {
    const {
      firstName,
      lastName,
      companyName,
      address,
      state,
      city,
      zip,
      mobile_number,
      country,
      phone_number,
      email,
      codeMb,
      internalUser,
      accessroles,
    } = formvalues;
    // let accessRoleFormat =
    //   state.accessroles && state.accessroles.length > 0
    //     ? state.accessroles.map((role) => role.id)
    //     : [];
    let accessRoleFormat =
      accessroles && accessroles.length > 0
        ? accessroles.map((role) => role.id)
        : [];
    if (mandatoryFields["autoApproval"][pool] || internalUser) {
      return {
        email: email,
        given_name: firstName,
        name: companyName,
        family_name: lastName,
        address: address,
        phone_number: mobile_number ? "+" + codeMb + mobile_number : "",
        "custom:displayname": `${lastName},${firstName}`,
        "custom:company": companyName,
        "custom:phoneNumber": phone_number,
        "custom:mobileNumber": mobile_number
          ? "+" + codeMb + mobile_number
          : "",
        "custom:Groups":
          accessRoleFormat.length > 0 ? accessRoleFormat.join(",") : " ",
        "custom:status": "ACTIVE",
        "custom:Address": address,
        "custom:City": city,
        "custom:State": state,
        "custom:Zip": zip,
        "custom:Country": country,
        autoApproval: mandatoryFields["autoApproval"][pool],
        internalUser: internalUser,
      };
    } else {
      return {
        email: email,
        given_name: firstName,
        name: companyName,
        family_name: lastName,
        address: address,
        phone_number: mobile_number ? "+" + codeMb + mobile_number : "",
        custom_displayname: `${lastName},${firstName}`,
        custom_company: companyName,
        custom_telephone: phone_number,
        custom_mobileNumber: mobile_number ? "+" + codeMb + mobile_number : "",
        custom_Groups:
          accessRoleFormat.length > 0 ? accessRoleFormat.join(",") : " ",
        custom_status: "PENDING",
        custom_city: city,
        custom_state: state,
        custom_zip: zip,
        custom_country: country,
      };
    }
  };

  const updateUserObject = (formvalues, uid, existingStatus) => {
    const {
      firstName,
      lastName,
      companyName,
      address,
      state,
      city,
      zip,
      mobile_number,
      country,
      phone_number,
      codeMb,
      status,
      disableUser,
      emailVerified,
      accessroles,
    } = formvalues;
    // let accessRoleFormat =
    //   state.accessroles && state.accessroles.length > 0
    //     ? state.accessroles.map((role) => role.id)
    //     : [];
    let accessRoleFormat = accessroles
      ? accessroles.map((role) => role.id)
      : [];
    return {
      email: uid,
      given_name: firstName || " ",
      name: companyName || " ",
      family_name: lastName || " ",
      address: address || " ",
      phone_number: mobile_number ? "+" + codeMb + mobile_number : " ",
      "custom:displayname": `${lastName},${firstName}` || " ",
      "custom:company": companyName || " ",
      "custom:phoneNumber": phone_number || " ",
      "custom:mobileNumber": mobile_number ? "+" + codeMb + mobile_number : " ",
      "custom:Groups":
        accessRoleFormat.length > 0 ? accessRoleFormat.join(",") : " ",
      "custom:status": status,
      "custom:Address": address || " ",
      "custom:City": city || " ",
      "custom:State": state || " ",
      "custom:Zip": zip || " ",
      "custom:Country": country || " ",
      email_verified: emailVerified.toString(),
      disableUser: disableUser,
    };
  };

  const generatePhoneNumber = (number) => {
    let code =
      number && number.length > 10 && number.substring(1, number.length - 10);
    let ph_number =
      number &&
      number.length > 10 &&
      number.substring(number.length - 10, number.length);
    return {
      code: code || "",
      ph_number: ph_number || "",
    };
  };
  // const { isLoading, error, pool, userDetails, roles } = props;

  return (
    <DocumentTitle
      title={`Doorkeeper | ${!state.userID ? "Create User" : "Modify User"}`}
    >
      <React.Fragment>
        <h5>{!state.userID ? "Create User" : "Modify User"}</h5>
        <Formik
          enableReinitialize={state.aTouch ? false : true}
          initialValues={{
            firstName: (userDetails && userDetails.given_name) || "",
            lastName: (userDetails && userDetails.family_name) || "",
            companyName: (userDetails && userDetails["custom:company"]) || "",
            address: (userDetails && userDetails["custom:Address"]) || "",
            state: (userDetails && userDetails["custom:State"]) || "",
            city: (userDetails && userDetails["custom:City"]) || "",
            zip: (userDetails && userDetails["custom:Zip"]) || "",
            sapcontactid:
              (userDetails && userDetails["custom:sapcontactid"]) || "",
            sapaccountid:
              (userDetails && userDetails["custom:sapAccountid"]) || "",
            resourceid: (userDetails && userDetails["custom:resourceid"]) || "",
            contracttype:
              (userDetails && userDetails["custom:contracttype"]) || "",
            salesorg: (userDetails && userDetails["custom:salesOrg"]) || "",
            mobile_number:
              (userDetails &&
                generatePhoneNumber(userDetails["phone_number"]).ph_number) ||
              "",
            country: (userDetails && userDetails["custom:Country"]) || "",
            phone_number:
              (userDetails && userDetails["custom:phoneNumber"]) || "",
            email: (userDetails && userDetails["email"]) || "",
            accessroles: (userDetails && state.accessroles) || [],
            codeMb:
              (userDetails &&
                generatePhoneNumber(userDetails["phone_number"]).code) ||
              formatCountryCodes(pool).length === 2
                ? formatCountryCodes(pool)[1]
                : "",
            userid: userDetails && userDetails["custom:uid"],
            status:
              userDetails &&
              (String(userDetails["custom:usertype"])?.toLowerCase() ===
              "internal"
                ? "Internal"
                : userDetails["Enabled"]
                ? userDetails["UserStatus"] === "CONFIRMED"
                  ? "ACTIVE"
                  : "FORCE_CHANGE_PASSWORD"
                : "DISABLED"),
            disableUser: userDetails && !userDetails["Enabled"],
            emailVerified:
              userDetails &&
              userDetails?.email_verified?.toLowerCase() === "true",
            internalUser: false,
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .required("Email is required")
              .email("Invalid email")
              .when("internalUser", {
                is: (internalUser) => internalUser,
                then: () =>
                  Yup.string().test(
                    "internal user validation",
                    "Invalid internal user email id",
                    (email) => {
                      return String(email)
                        ?.toLowerCase()
                        .includes("@sony.com") ||
                        String(email)?.toLowerCase().includes("@ap.sony.com")
                        ? true
                        : false;
                    }
                  ),
              }),
            firstName: Yup.string()
              .required("First Name is required")
              .test("validateFirstName", "Invalid First Name", (firstName) => {
                return isEmpty(String(firstName).trim()) ? false : true;
              }),
            lastName: Yup.string()
              .required("Last Name is required")
              .test("validateLastName", "Invalid Last Name", (lastName) => {
                return isEmpty(String(lastName).trim()) ? false : true;
              }),
            codeMb: Yup.string().when("mobile_number", {
              is: (mobile_number) => mobile_number,
              then: () => Yup.string().required("Code required"),
            }),
            mobile_number: Yup.string()
              .matches(/^[0-9]+$/, "Must be only digits")
              .min(10, "Must be exactly 10 digits")
              .max(10, "Must be exactly 10 digits"),
            accessRole: mandatoryFields["roles"][pool]
              ? () =>
                  Yup.array()
                    .min(1, "Pick atleast one Role")
                    .of(
                      Yup.object().shape({
                        id: () => Yup.string().required(),
                        label: () => Yup.string().required(),
                      })
                    )
              : null,
            companyName: mandatoryFields["companyName"][pool]
              ? () =>
                  Yup.string()
                    .required("Companyname is required")
                    .test(
                      "validateFirstName",
                      "Invalid Company Name",
                      (companyName) => {
                        return isEmpty(String(companyName).trim())
                          ? false
                          : true;
                      }
                    )
              : null,
          })}
          onSubmit={(values) => {
            clearError();
            clearUserCreated();
            clearModifyUser();
            const finalObject = !state.userID
              ? createUserObject(values)
              : // : updateUserObject(values, state.userID, state.existingStatus);
                updateUserObject(values, state.userID);

            !state.userID
              ? createUserMethod(finalObject)
              : modifyUserMethod(finalObject);
          }}
          onReset={() => {
            clearError();
            let newState = {
              modal: false,
              message: "",
              color: "",
              aTouch: false,
            };
            setState((prevState) => ({
              ...prevState,
              ...newState,
            }));
            if (state.userID) {
              clearModifyUser();
            } else {
              let newState = {
                accessroles: [],
              };
              setState((prevState) => ({
                ...prevState,
                ...newState,
              }));
              clearUserCreated();
            }
          }}
        >
          {({
            handleSubmit,
            values,
            handleBlur,
            touched,
            errors,
            setFieldValue,
            handleReset,
            isSubmitting,
            isValidating,
          }) => (
            <Container
              style={{
                border: "1.5px solid #ddd",
                padding: "1% 5%",
                overflowY: "auto",
                height: "70vh",
              }}
            >
              {isLoading && !error && <Loading />}
              {state.modal && (
                <SubmissionPopup
                  modal={state.modal}
                  toggle={() => {
                    toggle();
                    handleReset();
                  }}
                  message={state.message}
                  color={state.color}
                />
              )}
              <Form onSubmit={handleSubmit}>
                <ErrorFocus
                  errors={errors}
                  isSubmitting={isSubmitting}
                  isValidating={isValidating}
                />
                {state.userID && (
                  <FormGroup row>
                    <Col>
                      <Label>
                        User ID:
                        {"  "}
                      </Label>
                      <Input
                        type="text"
                        name="userid"
                        tag={Field}
                        disabled={state.disabled}
                      />
                    </Col>

                    <Col>
                      <Label>
                        Email ID:<span className="required">*</span>
                        {"  "}
                      </Label>
                      <Input
                        type="email"
                        name="email"
                        tag={Field}
                        disabled={state.disabled}
                      />
                    </Col>
                  </FormGroup>
                )}
                <FormGroup row>
                  {!state.userID && (
                    <Col>
                      <Label>
                        Email ID:<span className="required">*</span>
                        {"  "}
                      </Label>
                      <Input
                        type="email"
                        name="email"
                        tag={Field}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          setFieldValue("email", event.target.value);
                        }}
                      />
                      <ErrorMessage
                        errors={errors.email}
                        touched={touched.email}
                      />{" "}
                    </Col>
                  )}
                  <Col>
                    <Label>
                      First Name:<span className="required">*</span>
                    </Label>
                    <Input
                      type="text"
                      name="firstName"
                      tag={Field}
                      maxLength={30}
                      onBlur={handleBlur}
                      onChange={(event) => {
                        setFieldValue("firstName", event.target.value);
                      }}
                    />
                    <ErrorMessage
                      errors={errors.firstName}
                      touched={touched.firstName}
                    />{" "}
                  </Col>
                  <Col>
                    <Label>
                      Last Name:<span className="required">*</span>
                      {"  "}
                    </Label>
                    <Input
                      type="text"
                      name="lastName"
                      tag={Field}
                      maxLength={30}
                      onBlur={handleBlur}
                      onChange={(event) => {
                        setFieldValue("lastName", event.target.value);
                      }}
                    />
                    <ErrorMessage
                      errors={errors.lastName}
                      touched={touched.lastName}
                    />{" "}
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Col sm="6">
                    <Label>
                      Company Name:
                      {mandatoryFields["companyName"][pool] && (
                        <span className="required">*</span>
                      )}
                    </Label>
                    <Input
                      type="text"
                      name="companyName"
                      tag={Field}
                      maxLength={50}
                      onBlur={handleBlur}
                      onChange={(event) => {
                        setFieldValue("companyName", event.target.value);
                      }}
                    />
                    <ErrorMessage
                      errors={errors.companyName}
                      touched={touched.companyName}
                    />
                  </Col>
                  <Col>
                    <Label>Company Phone Number:</Label>
                    <Input
                      type="text"
                      name="phone_number"
                      tag={Field}
                      maxLength={30}
                      onBlur={handleBlur}
                      onChange={(event) => {
                        setFieldValue("phone_number", event.target.value);
                      }}
                    />
                    <ErrorMessage
                      errors={errors.phone_number}
                      touched={touched.phone_number}
                    />
                  </Col>{" "}
                </FormGroup>
                <FormGroup row>
                  <Col>
                    <Label>Mobile Number:</Label>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <Input
                          addon
                          component="select"
                          tag={Field}
                          name="codeMb"
                          value={values.codeMb}
                          disabled={formatCountryCodes(pool).length === 2}
                          onChange={(e) =>
                            setFieldValue("codeMb", e.target.value)
                          }
                        >
                          {optionListCountries(formatCountryCodes(pool))}{" "}
                        </Input>
                      </InputGroupAddon>
                      <Input
                        maxLength={10}
                        type={"text"}
                        name="mobile_number"
                        tag={Field}
                        onChange={(event) => {
                          setFieldValue("mobile_number", event.target.value);
                        }}
                        onBlur={handleBlur}
                        value={values.mobile_number}
                      />{" "}
                    </InputGroup>
                    <ErrorMessage
                      errors={errors.codeMb}
                      touched={touched.codeMb}
                    />
                    <ErrorMessage
                      errors={errors.mobile_number}
                      touched={touched.mobile_number}
                    />{" "}
                  </Col>{" "}
                  <Col>
                    <Label>Address:</Label>
                    <Input
                      component={"textarea"}
                      name="address"
                      tag={Field}
                      maxLength={2048}
                      onChange={(event) => {
                        setFieldValue("address", event.target.value);
                      }}
                      onBlur={handleBlur}
                      value={values.address}
                    />
                    <ErrorMessage
                      errors={errors.address}
                      touched={touched.address}
                    />{" "}
                  </Col>
                  <Col>
                    <Label>City:</Label>
                    <Input
                      type={"text"}
                      name="city"
                      maxLength={30}
                      tag={Field}
                      onChange={(event) => {
                        setFieldValue("city", event.target.value);
                      }}
                      onBlur={handleBlur}
                      value={values.city}
                    />
                    <ErrorMessage errors={errors.city} touched={touched.city} />{" "}
                  </Col>{" "}
                </FormGroup>
                <FormGroup row>
                  <Col>
                    <Label>State:</Label>
                    <Input
                      name="state"
                      tag={Field}
                      onChange={(event) => {
                        setFieldValue("state", event.target.value);
                      }}
                      onBlur={handleBlur}
                      value={values.state}
                    />
                    <ErrorMessage
                      errors={errors.state}
                      touched={touched.state}
                    />{" "}
                  </Col>
                  <Col>
                    <Label>Country:</Label>
                    <Input
                      component={"select"}
                      name="country"
                      tag={Field}
                      onChange={(event) => {
                        setFieldValue("country", event.target.value);
                      }}
                    >
                      {optionListCountries(countries)}
                    </Input>
                    <ErrorMessage
                      errors={errors.country}
                      touched={touched.country}
                    />{" "}
                  </Col>
                  <Col>
                    <Label>Zip:</Label>
                    <Input
                      type={"text"}
                      name="zip"
                      tag={Field}
                      maxLength={10}
                      onChange={(event) => {
                        setFieldValue("zip", event.target.value);
                      }}
                      onBlur={handleBlur}
                      value={values.zip}
                    />
                    <ErrorMessage errors={errors.zip} touched={touched.zip} />{" "}
                  </Col>{" "}
                </FormGroup>
                {mandatoryFields["showSapFields"][pool] && (
                  <FormGroup>
                    <FormGroup row>
                      <Col>
                        <Label>SAP Contact Id:</Label>
                        <Input
                          type={"text"}
                          name="sapcontactid"
                          tag={Field}
                          maxLength={10}
                          onChange={(event) => {
                            setFieldValue("sapcontactid", event.target.value);
                          }}
                          onBlur={handleBlur}
                          value={values.sapcontactid}
                        />
                        <ErrorMessage
                          errors={errors.sapcontactid}
                          touched={touched.sapcontactid}
                        />{" "}
                      </Col>{" "}
                      <Col>
                        <Label>SAP Account Id:</Label>
                        <Input
                          type={"text"}
                          name="sapaccountid"
                          tag={Field}
                          maxLength={10}
                          onChange={(event) => {
                            setFieldValue("sapaccountid", event.target.value);
                          }}
                          onBlur={handleBlur}
                          value={values.sapaccountid}
                        />
                        <ErrorMessage
                          errors={errors.sapaccountid}
                          touched={touched.sapaccountid}
                        />{" "}
                      </Col>{" "}
                      <Col>
                        <Label>Resource Id:</Label>
                        <Input
                          type={"text"}
                          name="resourceid"
                          tag={Field}
                          maxLength={10}
                          onChange={(event) => {
                            setFieldValue("resourceid", event.target.value);
                          }}
                          onBlur={handleBlur}
                          value={values.resourceid}
                        />
                        <ErrorMessage
                          errors={errors.resourceid}
                          touched={touched.resourceid}
                        />{" "}
                      </Col>{" "}
                    </FormGroup>

                    <FormGroup row>
                      <Col>
                        <Label>Contract Type:</Label>
                        <Input
                          type={"text"}
                          name="contracttype"
                          tag={Field}
                          maxLength={30}
                          onChange={(event) => {
                            setFieldValue("contracttype", event.target.value);
                          }}
                          onBlur={handleBlur}
                          value={values.contracttype}
                        />
                        <ErrorMessage
                          errors={errors.contracttype}
                          touched={touched.contracttype}
                        />{" "}
                      </Col>{" "}
                      <Col>
                        <Label>Sales Org:</Label>
                        <Input
                          component={"select"}
                          name="salesorg"
                          tag={Field}
                          onChange={(event) => {
                            setFieldValue("salesorg", event.target.value);
                          }}
                        >
                          {optionListCountries(salesorgs)}
                        </Input>
                        <ErrorMessage
                          errors={errors.salesorg}
                          touched={touched.salesorg}
                        />{" "}
                      </Col>
                    </FormGroup>
                  </FormGroup>
                )}
                <FormGroup row></FormGroup>
                {roles && roles.length > 0 && (
                  <FormGroup row>
                    <Col md={2}>
                      <Label className="floatLeft">
                        Access Role(s):
                        {mandatoryFields["roles"][pool] && (
                          <span className="required">*</span>
                        )}
                      </Label>
                    </Col>
                    <Col md={12}>
                      <MultiSelect
                        name={"accessroles"}
                        items={roles}
                        selectedItems={state.accessroles}
                        onChange={(accessroles) => {
                          let newState = {
                            accessroles: accessroles,
                            aTouch: true,
                          };
                          setState((prevState) => ({
                            ...prevState,
                            ...newState,
                          }));

                          setFieldValue("accessroles", accessroles);
                        }}
                      />
                      <ErrorMessage
                        errors={errors.accessroles}
                        touched={touched.accessroles}
                      />{" "}
                    </Col>
                  </FormGroup>
                )}
                {state.userID ? (
                  <FormGroup row>
                    <Col md={5}>
                      <FormGroup>
                        <Label for="status" id="status" className="label">
                          Status:
                        </Label>
                        <Label for="status" id="status">
                          {values.status}
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup>
                        <Label check for="disableUser" className="label">
                          Disable User: &nbsp; &nbsp; &nbsp;
                          <Input
                            id="disableUser"
                            type="checkbox"
                            name="disableUser"
                            aria-label="disableUser"
                            checked={values.disableUser}
                            onChange={(event) => {
                              setFieldValue(
                                "disableUser",
                                event.target.checked
                              );
                            }}
                          />
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label check for="emailVerified" className="label">
                          Email Verified :
                        </Label>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Input
                          type={"checkbox"}
                          name="emailVerified"
                          checked={values.emailVerified}
                          onChange={(e) => {
                            setFieldValue("emailVerified", e.target.checked);
                          }}
                        />
                        <ErrorMessage
                          errors={errors.emailVerified}
                          touched={touched.emailVerified}
                        />{" "}
                      </FormGroup>
                    </Col>{" "}
                  </FormGroup>
                ) : mandatoryFields["showInternal"][pool] ? (
                  <FormGroup row>
                    <Col md={6}>
                      <FormGroup>
                        <Label
                          for="internalUser"
                          id="internalUser"
                          className="label"
                        >
                          Internal User:
                        </Label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Input
                          type={"checkbox"}
                          name="internalUser"
                          checked={values.internalUser}
                          onChange={(e) => {
                            setFieldValue("internalUser", e.target.checked);
                          }}
                        />
                        <ErrorMessage
                          errors={errors.internalUser}
                          touched={touched.internalUser}
                        />{" "}
                      </FormGroup>
                    </Col>
                  </FormGroup>
                ) : (
                  ""
                )}
                <FormGroup row>
                  <Col className="text-center text-md-right">
                    <Button
                      type="reset"
                      tag={Link}
                      to={state.userID ? "/modify" : "/"}
                    >
                      Cancel
                    </Button>
                    &nbsp;
                    <Button type="submit">Submit</Button>
                  </Col>
                </FormGroup>
              </Form>
            </Container>
          )}
        </Formik>
      </React.Fragment>
    </DocumentTitle>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.fetch.isLoading,
    error: state.error.error_obj,
    userDetails: state.users.userDetails,
    roles: state.users.roles,
    // companies: state.users.companies,
    pool: state.pool.userPool,
    userCreated: state.users.usercreated,
    userModified: state.users.userModified,
  };
};

export default connect(mapStateToProps)(CreateUserForm);
